import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const HonoreesListItem = ({
  title,
  url,
  description = 'Ad consectetur commodo amet excepteur magna veniam ullamco est duis consequat laborum aute minim.',
  icon = 'https://placehold.co/100x100/3d4070/ffffff?text=ICON',
  iconHover
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={clsx('list-item', 'honoree')}
      onClick={() => window.open(url, '_blank')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="list-item-content">
        <div className="list-item-content__icon">
          <img src={isHovered && iconHover ? iconHover : icon} alt="icon" />
        </div>

        <div className="list-item-content__honoree-info">
          <h2 className="list-item-content__honoree-info--title">{title}</h2>
          <div
            className="list-item-content__honoree-info--description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>

        <div className="list-item-content__arrow">→</div>
      </div>
    </div>
  );
};

HonoreesListItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconHover: PropTypes.string
};

HonoreesListItem.defaultProps = {
  iconHover: null
};

export default HonoreesListItem;
